import { breakpointOf, breakpoints, columnGapFor, gutterFor, layout } from '../layout';
/**
 * WEB SAYFA RAYLARI — yeni görünüm R turu (kullanıcı kararı 29.10.2026: "web
 * sayfa genişliği tasarımın verdiği gibi olur").
 *
 * ÖLÇÜLDÜ (`docs/design/yeni-gorunum/components/*` 1440 kartları): en geniş
 * içerik 1360 px, kenarlar 40 px. Site keşfi (`SiteEtkinlikler`), katılımcı
 * etkinlikleri ve cüzdan `max-width:1360px; padding:0 40px` çizer; katılımcı
 * menüsü `padding:0 40px` ile aynı kenardan başlar. Ray kenar boşluğunu İÇİNDE
 * taşır (`max-width` ray, `padding-inline` merdiven, l ve üstünde 32), bu
 * yüzden 1360 içerik = 1360 + 2 × 32 = **1424** ray; 1440 ekranda içerik
 * 40 px'ten başlar. Site ve uygulama kabukları AYNI rayı kullanır: ana sayfa
 * menüsü, keşif ve kurum ekranları arasında sol içerik kenarı zıplamaz.
 *
 * Ray xxl'de BÜYÜMEZ: kartların `max-width` değeri sabittir (1360). Eski
 * Revizyon 2'nin `min(78vw, 1760)` basamağı yalnız yönetim panelinde
 * (`apps/admin`, kendi düzenini korur) kalır, bkz. `railProfiles.admin`.
 *
 * `reading` (880) değişmez: metin yüzeyi, satır uzunluğu sınırı.
 *
 * NEDEN `layout.ts`te DEĞİL: `layout` nesnesi mobil temasının parmak izindedir
 * (`mobil-tema-donmus.guard.spec.ts`, M-1). Orada `rails` değişirse mobil
 * fikstürü kırılır. Web değerleri bu yüzden web temasında durur (plan 3.2,
 * seçenek B); `layout.rails` mobil ve yönetim paneli için donmuş kalır.
 */
/**
 * SİTE KABUĞU — tech-lead B turu (29.10.2026, kullanıcı: "tasarım nasılsa öyle
 * olsun"). Misafir site sayfalarının kartları (SiteAnaSayfa, SiteBizeUlasin,
 * SiteYasal, SiteGiris …) menüyü, girişi ve altbilgiyi 1440'ta **80 px**,
 * 1280'de **40 px** kenarla çizer (`padding:0 80px` · SiteAnaSayfa1280
 * `padding:0 40px`). İkisi tek kuralın iki ucudur: içerik en çok **1280**, kenar
 * xl ve üstünde **40**. Ray kenarı içinde taşır: 1280 + 2 × 40 = **1360**.
 * xl altında kenar uygulama merdiveninden gelir (16 · 24 · 32).
 *
 * Uygulama kabuğu (keşif, katılımcı, panel) 1424 / 32'de kalır; R turunun "her
 * kabukta aynı sol kenar" kuralı kabuk TÜRÜ içinde geçerlidir.
 */
export const webSiteShell = {
    content: 1280,
    edge: { minWidth: breakpoints.xl, padding: 40 },
    /*
     * Site kabuğunun İÇ SÜTUNLARI (ray değil): kartların ortalı `main` kutuları.
     * SiteBizeUlasin `max-width:1100px`, SiteYasal `max-width:1200px` (ikisi de
     * 40 px yan dolguyla; site rayının içinde ortalanınca aynı x'e düşer).
     * `article`: SiteYasal metin sütunu (`<article style="max-width:720px">`).
     */
    columns: { form: 1100, document: 1200, article: 720 },
};
export const webRails = {
    app: 1424,
    reading: layout.rails.reading,
    public: 1424,
    site: webSiteShell.content + webSiteShell.edge.padding * 2,
};
/** Ray profili: web (yeni görünüm) ya da yönetim paneli (Revizyon 2, donmuş). */
export const railProfiles = {
    web: { rails: webRails, wide: null },
    admin: { rails: layout.rails, wide: layout.railWide },
};
/**
 * `:root` bloğunun ray değişkenleri (`--ib-rail-app|reading|public|site`). Web
 * profilinde site kabuğunun kenarı (`--ib-gutter-site`, taban merdiveni izler)
 * ve iç sütunları (`--ib-site-column-*`) da buradan gelir.
 */
export function railCssDeclarations(profile) {
    const rails = Object.entries(railProfiles[profile].rails).map(([key, value]) => `--ib-rail-${key}: ${value}px;`);
    if (profile !== 'web')
        return rails;
    return [...rails, '--ib-gutter-site: var(--ib-gutter);', ...siteColumnDeclarations()];
}
/** Rayın xxl basamağı: yalnız `admin` profilinde (`min(78vw, 1760px)`), web'de boş. */
export function wideRailRules(profile) {
    const wide = railProfiles[profile].wide;
    if (!wide)
        return [];
    return [
        `@media (min-width:${wide.minWidth}px){:root{--ib-rail-app:min(${wide.vw}vw,${wide.maxPx}px);}}`,
    ];
}
/** Site kabuğunun kenarı (`--ib-gutter-site`): xl ve üstünde 40, altında merdiven. */
export function siteGutterFor(width) {
    return width >= webSiteShell.edge.minWidth ? webSiteShell.edge.padding : gutterFor(width);
}
/** Site rayının o ekran genişliğindeki ölçüsü: `min(1360, w)`. */
export function siteRailWidthFor(width) {
    return Math.min(webRails.site, width);
}
/** Site kabuğunun sol içerik kenarı (alan genişliğinde): 1440 → 80, 1280 → 40, 390 → 16. */
export function siteContentLeft(width) {
    return Math.max(0, (width - siteRailWidthFor(width)) / 2) + siteGutterFor(width);
}
/**
 * `--ib-gutter-site` kuralları: taban `:root`ta merdiveni okur, xl basamağı
 * 40'a çıkar. Yalnız `web` profili (yönetim panelinde site kabuğu yok).
 */
export function siteGutterRules(profile) {
    if (profile !== 'web')
        return [];
    const { minWidth, padding } = webSiteShell.edge;
    return [`@media (min-width:${minWidth}px){:root{--ib-gutter-site:${padding}px;}}`];
}
/** Site iç sütunlarının değişkenleri (`--ib-site-column-form|document`). */
export function siteColumnDeclarations() {
    return Object.entries(webSiteShell.columns).map(([key, value]) => `--ib-site-column-${key}: ${value}px;`);
}
/** Web rayının o ekran genişliğindeki ölçüsü: `min(1424, w)`. */
export function railWidthFor(width) {
    return Math.min(webRails.app, width);
}
/**
 * ORTA KOLONUN genişliği (Revizyon 2 `midOf(w)`, web rayıyla). `MID_MIN` (510)
 * bunun üzerinde doğrulanır; ızgara eşiği (760) de buna bakar. `detail` kolonu
 * yalnız xl ve xxl'de ızgaradadır, yan menü `l`den itibaren açıktır.
 */
export function midColumnWidth(width, options = {}) {
    const bp = breakpointOf(width);
    const usable = railWidthFor(width) - gutterFor(width) * 2;
    const sideNav = options.sideNav && bp !== 'sm' && bp !== 'md' ? layout.rhythm.sideNavWidth : 0;
    const detail = options.detail && (bp === 'xl' || bp === 'xxl') ? layout.columns.detail : 0;
    const columns = (sideNav ? 1 : 0) + (detail ? 1 : 0);
    return usable - sideNav - detail - columnGapFor(width) * columns;
}
/**
 * KATILIMCI DİZİNİNİN ORTA KOLONU (tasarımın `midFor(w)`i, 224/304 kolon
 * çifti). Süzgeç `l` ve üstünde, detay `xl` ve üstünde ızgaradadır. Kapı:
 * `dizin-kirilim.guard.spec.ts`.
 */
export function attendeeDirectoryMidWidth(width) {
    const bp = breakpointOf(width);
    const usable = railWidthFor(width) - gutterFor(width) * 2;
    const filter = bp === 'sm' || bp === 'md' ? 0 : layout.columns.directoryFilter;
    const detail = bp === 'xl' || bp === 'xxl' ? layout.columns.directoryDetail : 0;
    const columns = (filter ? 1 : 0) + (detail ? 1 : 0);
    return usable - filter - detail - columnGapFor(width) * columns;
}
//# sourceMappingURL=yerlesim.js.map